import { useState } from 'react';
import { FOLDERS, FILES, CASE_STUDIES } from '../profileConstants';

const useExplorerState = () => {
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [selectedSubfolder, setSelectedSubfolder] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedCaseStudy, setSelectedCaseStudy] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewMode, setViewMode] = useState('list');
  const [selectedIconItem, setSelectedIconItem] = useState(null);
  const [iconViewPath, setIconViewPath] = useState([]);

  const handleFolderClick = (folderName) => {
    setSelectedFolder(prev => prev === folderName ? null : folderName);
    setSelectedSubfolder(null);
    setSelectedFile(null);
    setSelectedCaseStudy(null);
  };

  const handleSubfolderClick = (subfolderName) => {
    setSelectedSubfolder(prev => prev === subfolderName ? null : subfolderName);
    setSelectedFile(null);
    setSelectedCaseStudy(null);
  };

  const handleFileClick = (fileName) => {
    if (fileName === 'resume.pdf') {
      window.open('/vimarsh.pdf', '_blank');
      return;
    }
    // Toggle selection if clicking the same file
    if (selectedFile === fileName) {
      setSelectedFile(null);
    } else {
      setSelectedFile(fileName);
      setSelectedCaseStudy(null);
      if (window.innerWidth < 1024) setIsModalOpen(true);
    }
  };

  const handleCaseStudyClick = (caseStudyName) => {
    // Toggle selection if clicking the same case study
    if (selectedCaseStudy === caseStudyName) {
      setSelectedCaseStudy(null);
    } else {
      setSelectedCaseStudy(prev => prev === caseStudyName ? null : caseStudyName);
      setSelectedFile(null);
      if (window.innerWidth < 1024) setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => setIsModalOpen(false);

  const handleIconItemDoubleClick = (itemName, itemType) => {
    if (itemType === 'folder') {
      setIconViewPath([...iconViewPath, itemName]);
      setSelectedIconItem(null);
      setSelectedFile(null);
      setSelectedCaseStudy(null);
      return;
    }
    if (itemType === 'file') {
      if (itemName === 'resume.pdf') {
        window.open('/vimarsh.pdf', '_blank');
        return;
      }
      setSelectedFile(itemName);
      setSelectedCaseStudy(null);
      return;
    }
    if (itemType === 'caseStudy') {
      setSelectedCaseStudy(itemName);
      setSelectedFile(null);
    }
  };

  const handleIconItemClick = (itemName, itemType) => {
    setSelectedIconItem({ name: itemName, type: itemType });
  };

  const handleBreadcrumbClick = (index) => {
    if (index === -1) setIconViewPath([]);
    else setIconViewPath(iconViewPath.slice(0, index + 1));
    setSelectedIconItem(null);
    setSelectedFile(null);
    setSelectedCaseStudy(null);
  };

  return {
    selectedFolder,
    selectedSubfolder,
    selectedFile,
    selectedCaseStudy,
    isModalOpen,
    viewMode,
    selectedIconItem,
    iconViewPath,
    handleFolderClick,
    handleSubfolderClick,
    handleFileClick,
    handleCaseStudyClick,
    handleCloseModal,
    handleIconItemDoubleClick,
    handleIconItemClick,
    handleBreadcrumbClick,
    setViewMode
  };
};

export default useExplorerState;
